export { default } from './getSlsBasePath';
